import { render, staticRenderFns } from "./result-hover-opportunities.vue?vue&type=template&id=685d60a6&scoped=true&"
import script from "./result-hover-opportunities.vue?vue&type=script&lang=js&"
export * from "./result-hover-opportunities.vue?vue&type=script&lang=js&"
import style0 from "./result-hover-opportunities.vue?vue&type=style&index=0&id=685d60a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685d60a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VFlex,VIcon,VLayout,VTooltip})
